export default __webpack_public_path__ + "static/media/Aakash_.f665b8c1.svg";